import type { EntityConfig } from '../types'

export const tierEntity: EntityConfig = {
  id: 'tier',
  displayName: 'Tier',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
    ],
    mappings: {
      all: ['active', 'inactive'],
      active: ['active'],
      inactive: ['inactive'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['status'],
}
